
// DashboardLayout.jsx
import React, { useState } from 'react';
import Sidebar from '../components/Sidebar/Sidebar';
import Header from '../components/Sidebar/Header';
import { Outlet } from 'react-router';

const Shared = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev);

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar isCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} />
      <div style={{ flexGrow: 1 }}>
        <Header toggleSidebar={toggleSidebar} />
        <div style={{ paddingTop: '70px', paddingLeft: '20px' }}>
          <Outlet /> {/* <-- This replaces children and renders nested content */}
        </div>
      </div>
    </div>
  );
};

export default Shared;
